import { Button, Card, CardContent, Divider, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useState } from "react";
import StyledSoftTab from "src/components/styled-soft-tab";
import {
  AreaChartByKeyword,
  AreaChartByDate,
  Top5WordsDataType,
  WordCloudChartType,
} from "src/types/types";

type Statistic = {
  statistics: {
    title: string | undefined;
    data: AreaChartByDate | undefined | AreaChartByKeyword | WordCloudChartType;
    component: JSX.Element | undefined;
  }[];
};

const DashboardStatisticsGroupContainer = ({
  statistics,
}: {
  statistics: Statistic["statistics"];
}) => {
  const [currentTab, setCurrentTab] = useState(0);

  return (
    <Card>
      <CardContent>
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12}>
            <Typography>Statistics</Typography>
          </Grid>
          <Grid item xs={12}>
            <Divider
              sx={{
                borderStyle: "dashed",
                opacity: 0.24,
                borderColor: "#0B1D60",
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Tabs
              value={currentTab}
              onChange={(_, newValue) => setCurrentTab(newValue)}
              TabIndicatorProps={{
                style: {
                  display: "none",
                },
              }}
            >
              {statistics.map((statistic, index) => (
                <StyledSoftTab
                  onClick={() => setCurrentTab(index)}
                  selected={currentTab === index}
                  title={statistic.title!}
                />
              ))}
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {statistics[currentTab].component}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default DashboardStatisticsGroupContainer;
